import React, { createContext, useState } from "react";

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [activeProject, setActiveProject] = useState(() => {
    const storedProject = localStorage.getItem("activeProject");
    return storedProject ? JSON.parse(storedProject) : null;
  });

  const login = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setActiveProject(null);
    localStorage.removeItem("user");
    localStorage.removeItem("activeProject");
  };

  const selectProject = (project) => {
    setActiveProject(project);
    localStorage.setItem("activeProject", JSON.stringify(project));
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        activeProject,
        selectProject,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
